import { useTranslation } from "react-i18next";
import { cld } from "../../utils/cld";

const Img37 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1757965884/37_btbbfa.jpg"
const Img38 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1757965884/38_msr2m1.jpg"

const About = () => {
  const { t } = useTranslation();

  return (
    <section
      style={{
        padding: "120px 20px",
        background: "linear-gradient(160deg, #FAF7F2 0%, #F3EEE6 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "-120px",
          right: "-120px",
          width: "480px",
          height: "480px",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(144,81,15,0.06) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "64px",
          flexWrap: "wrap",
          maxWidth: "1280px",
          margin: "0 auto",
          position: "relative",
          zIndex: 1,
        }}
      >
        <img
          src={cld(Img37, { w: 760 })}
          alt={t('about.imgAlt1')}
          width="614"
          height="390"
          loading="lazy"
          decoding="async"
          style={{
            width: "380px",
            height: "480px",
            objectFit: "cover",
            borderRadius: "24px",
            boxShadow: "0 24px 64px rgba(0,0,0,0.13)",
            flexShrink: 0,
          }}
        />

        <div style={{ maxWidth: "540px", textAlign: "center" }}>
          <p
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: "11px",
              fontWeight: "700",
              letterSpacing: "0.24em",
              textTransform: "uppercase",
              color: "#90510F",
              marginBottom: "20px",
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span style={{ display: "inline-block", width: "28px", height: "2px", background: "#90510F", borderRadius: "2px" }} />
            {t('about.eyebrow')}
            <span style={{ display: "inline-block", width: "28px", height: "2px", background: "#90510F", borderRadius: "2px" }} />
          </p>
          <h2
            style={{
              fontFamily: "'Cormorant Garamond', 'PT Serif', serif",
              fontSize: "clamp(2rem, 4vw, 3rem)",
              fontWeight: "600",
              lineHeight: "1.15",
              letterSpacing: "-0.01em",
              color: "#1A0D05",
              marginBottom: "28px",
            }}
          >
            {t('about.heading')}
          </h2>
          <p
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: "16px",
              lineHeight: "1.85",
              color: "#5a3a20",
              marginBottom: "20px",
            }}
          >
            {t('about.paragraph')}
          </p>
          <p
            style={{
              fontFamily: "'Cormorant Garamond', 'PT Serif', serif",
              fontSize: "20px",
              fontWeight: "600",
              fontStyle: "italic",
              color: "#90510F",
              marginBottom: 0,
            }}
          >
            {t('about.tagline')}
          </p>
        </div>

        <img
          src={cld(Img38, { w: 760 })}
          alt={t('about.imgAlt2')}
          width="760"
          height="507"
          loading="lazy"
          decoding="async"
          style={{
            width: "380px",
            height: "480px",
            objectFit: "cover",
            borderRadius: "24px",
            boxShadow: "0 24px 64px rgba(0,0,0,0.13)",
            flexShrink: 0,
          }}
        />
      </div>
    </section>
  );
};

export default About;
